import { render } from "./MovCaja.vue?vue&type=template&id=6820f392&scoped=true"
import script from "./MovCaja.vue?vue&type=script&lang=js"
export * from "./MovCaja.vue?vue&type=script&lang=js"

import "./MovCaja.vue?vue&type=style&index=0&id=6820f392&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6820f392"]])

export default __exports__